module.exports = __webpack_public_path__ + "img/ic-twt.4f219150.svg";